import React, { SyntheticEvent } from 'react';
import { useSelector } from 'react-redux';

import MSwitchView from './MSwitch.view';

import { AppState } from '../../models/app-store';

type Props = {
  color: 'primary' | 'info' | 'secondary';
  colorHex?: string;
  className?: string;
  classNameContent?: string;
  checked: boolean;
  name?: string;
  disabled?: boolean;
  size?: 'sm' | 'md';
  onChange: (checked: boolean, event: MouseEvent | SyntheticEvent<MouseEvent | KeyboardEvent, Event>, id: string) => void;
};

const MSwitch: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const darkMode = useSelector((state: AppState) => state.ui.darkMode);

  return (
    <MSwitchView
      color={props.color}
      colorHex={props.colorHex}
      className={props.className}
      classNameContent={props.classNameContent}
      checked={props.checked}
      name={props.name}
      disabled={props.disabled}
      size={props.size && 'sm'}
      darkMode={darkMode}
      onChange={props.onChange}
    >
      {props.children}
    </MSwitchView>
  );
};

MSwitch.displayName = 'MSwitch';
MSwitch.defaultProps = {};

export default MSwitch;
